const baseTealiumUrl = 'https://tags.tiqcdn.com/utag/cmsgov/medicare-www'

export const getUtagUrl = () => `${baseTealiumUrl}/${process.env.REACT_APP_MY_ENV}/utag.js`
export const getUtagSyncUrl = () => {
  let env = 'prod'
  if (process.env.REACT_APP_MEDICARE_ENV === 'dev1') {
    env = 'dev'
  }

  return `${baseTealiumUrl}/${env}/utag.sync.js`
}
